import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { IOrganization } from '../forget-password-dialog/forget-password-dialog.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import { IAuthenticationState } from 'src/app/state-management/states/aumye-authentication.state';

@Component({
  selector: 'app-select-organization-dialog',
  templateUrl: './select-organization-dialog.component.html',
  styleUrl: './select-organization-dialog.component.scss',
})
export class SelectOrganizationDialogComponent implements OnInit {
  orgControl = new FormControl();
  filteredOrganizations!: Observable<IOrganization[]>;
  organizations: IOrganization[] = [];
  selectedOrg!: IOrganization | null;
  data$: Observable<IAuthenticationState>;
  data: IAuthenticationState;
  destroyed$: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<IAumyeState>,
    private dialogRef: MatDialogRef<SelectOrganizationDialogComponent>
  ) {
    this.data$ = this.store.select('aumyeAuthenticationState');
    this.data$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.data = data;
      this.organizations = data.organizations;
    });
  }
  ngOnInit(): void {
    this.filteredOrganizations = this.orgControl.valueChanges.pipe(
      startWith(''),
      map((value) =>
        typeof value === 'string'
          ? value.toLowerCase()
          : value?.name?.toLowerCase() || ''
      ),
      map((name) =>
        this.organizations.filter((org) =>
          org.organizationName.toLowerCase().includes(name)
        )
      )
    );
  }

  displayFn = (org: IOrganization): string => org?.organizationName || '';

  onOrgSelected(org: IOrganization) {
    this.selectedOrg = org;
  }

  login() {
    if (this.selectedOrg) {
      this.dialogRef.close(this.selectedOrg); // Pass selected org back to parent
    }
  }
}
